import { schemaGenerator } from "../utils";

const common = {
  default: [
    "tw-w-[160px]",
    "tw-font-semibold",
    "tw-text-left",
    "tw-m-0",
    "tw-pr-[4px]",
    "tw-px-[12px]",
    "tw-border-0",
    "tw-border-solid",
    "tw-text-neutral-gray-75",
  ],
  hover: ["hover:tw-bg-neutral-gray-10"],
};

const dictionary = {
  regular: {
    default: [...common.default, "tw-pl-[24px]", "tw-bg-transparent"],
    hover: common.hover,
  },
  selected: {
    default: [
      ...common.default,
      "tw-pl-[20px]",
      "tw-border-l-[4px]",
      "tw-border-l-theme-nav-focus",
      "tw-bg-theme-nav-focus",
    ],
    hover: common.hover,
  },
  medium: {
    default: ["tw-h-[44px]", "tw-font-14d"],
  },
  small: {
    default: ["tw-h-[36px]", "tw-font-12d"],
  },
};

const schema = schemaGenerator(dictionary);

export default schema;
